<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Cuenta por Cobrar</h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelar()"  tabindex="211" >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="row">
            <div class="col-md-12">

                <div class="row mt-3" style="margin-top:15px !important">
                    <div class="col-md-12">
                        <div class="table-responsive" style="height: 550px;">
                            <table class="table table-sm table-striped table-bordered m-t-20 table-hover">
                                <thead>
                                    <tr>
                                        <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                                        <th style="white-space: nowrap"> T.C </th>
                                        <th style="white-space: nowrap"> Abrevi. </th>
                                        <th style="white-space: nowrap"> Comprobante </th>
                                        <th style="white-space: nowrap"> F.Operación </th>
                                        <th style="white-space: nowrap"> Moneda </th>
                                        <th style="white-space: nowrap"> Total Documento </th>
                                        <th style="white-space: nowrap"> Amortización </th>
                                        <th style="white-space: nowrap"> Saldo </th>
                                        <th style="white-space: nowrap"> Planilla </th>
                                        <th style="white-space: nowrap"> Descripción </th>
                                        <th style="white-space: nowrap"> Banco </th>
                                        <th style="white-space: nowrap"> #-Banco </th>
                                        <th style="white-space: nowrap"> Cpd.Canc </th>
                                        <th style="white-space: nowrap"> Tipo de cancelación </th>
                                        <th style="white-space: nowrap"> Operación </th>
                                        <th style="white-space: nowrap"> T.Cambio </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="cursor" *ngFor="let lst of detalles"  (click)="onClick(lst)" [ngClass]="{'nombre-de-la-clase': lst == this.cuentaColorTemp}">
                                        <td  style="text-align: center;">

                                            <div *ngIf="lst.planilla !== null" class="btn-group dropright" ngbDropdown container="body"
                                                role="group" aria-label="Button group with nested dropdown"
                                                style="margin: 0px; padding: 0px;">
                                                <button class="btn btn-sm" ngbDropdownToggle
                                                    style="margin: 0px; padding: 0px;">
                                                    <i class=" fas fa-align-left"></i>
                                                </button>
                                                <div *ngIf="lst.planilla!= null" class="dropdown-menu" ngbDropdownMenu>
                                                    <button class="dropdown-item" (click)="imprimir(lst)"><i
                                                            class="fas fa-print font-14"
                                                            style="margin-right: .3rem"></i>
                                                        Imprimir planilla</button>
                                                 
                                                </div>

                                            </div>

                                        </td>
                                            <td style="white-space: nowrap">{{lst.tipdoc}}</td>
                                            <td style="white-space: nowrap">{{lst.abrevi}}</td>
                                            <td  style="white-space: nowrap; text-align: right">{{lst.desdoc}}</td>
                                            <td style="white-space: nowrap">{{lst.femisi | date:'dd/MM/yyyy'}}</td>
                                            <td style="white-space: nowrap">{{lst.tipmon}}</td>
                                            <td style="white-space: nowrap; text-align: right">{{lst.tdocumento  | number:'.2-2'}}</td>
                                            <td style="white-space: nowrap; text-align: right ">{{lst.amorti  | number:'.2-2'}}</td>
                                            <td style="white-space: nowrap; text-align: right">{{lst.saldocalc | number:'.2-2'}}</td>
                                            <td style="white-space: nowrap">{{lst.planilla}}</td>
                                            <td style="white-space: nowrap">{{lst.descri}}</td>
                                            <td style="white-space: nowrap">{{lst.desban}}</td>
                                            <td style="white-space: nowrap">{{lst.codban}}</td>
                                            <td style="white-space: nowrap">{{lst.tipcan | number:'.3-3'}}</td>
                                            <td style="white-space: nowrap">{{lst.dtipcan}}</td>
                                            <td style="white-space: nowrap">{{lst.operac}}</td>
                                            <td style="white-space: nowrap">{{lst.tipcam}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
    </form>

    <!-- <div class="input-group m-t-15 d-flex justify-content-end">
        <button type="button" *ngIf="!editar" class="btn btn-rounded btn-success" tabindex="208" (click)="guardar()">
            <i class="fa fa-plus"></i> Adicionar </button>
        <button type="button" *ngIf="editar" class="btn btn-rounded btn-info" tabindex="208" (click)="guardar()">
            <i class="fa fa-check"></i> Actualizar </button>
        <button type="button" class="btn btn-rounded btn-warning" tabindex="209" (click)="cancelar()"
            data-bs-toggle="tooltip" title="Cancelar: Esc" (keydown.tab)="onNexFocus()"><i
                class="fa fa-times-circle"></i> Cancelar</button>
    </div> -->
</div>